import { InvoiceSentConfirmationInformationAdminzoneState } from "@/types/store/adminzone";
import { InvoiceSentConfirmationData } from "@/types";

export const state: InvoiceSentConfirmationInformationAdminzoneState = {
  invoiceConfirmationInformation: [] as Array<InvoiceSentConfirmationData>,
}
